<template>
  <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0005,6c-3.3141,0-6,2.687-6,6s2.6859,6,6,6c3.313,0,6-2.687,6-6
      S15.3135,6,12.0005,6z M12,17c-2.7568,0-5-2.2432-5-5s2.2432-5,5-5s5,2.2432,5,5S14.7568,17,12,17z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0004,5L12.0004,5c-0.2761,0-0.5-0.2239-0.5-0.5v-2
      c0-0.2761,0.2239-0.5,0.5-0.5h0c0.2761,0,0.5,0.2239,0.5,0.5v2C12.5004,4.7761,12.2765,5,12.0004,5z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0004,22L12.0004,22c-0.2761,0-0.5-0.2239-0.5-0.5v-2
      c0-0.2761,0.2239-0.5,0.5-0.5h0c0.2761,0,0.5,0.2239,0.5,0.5v2C12.5004,21.7761,12.2765,22,12.0004,22z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.0004,12L5.0004,12c0,0.2761-0.2239,0.5-0.5,0.5h-2
      c-0.2761,0-0.5-0.2239-0.5-0.5v0c0-0.2761,0.2239-0.5,0.5-0.5h2C4.7765,11.5,5.0004,11.7239,5.0004,12z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.0004,12L22.0004,12c0,0.2761-0.2239,0.5-0.5,0.5h-2
      c-0.2761,0-0.5-0.2239-0.5-0.5v0c0-0.2761,0.2239-0.5,0.5-0.5h2C21.7765,11.5,22.0004,11.7239,22.0004,12z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9501,7.0503L16.9501,7.0503c-0.1953-0.1953-0.1953-0.5118,0-0.7071
      l1.4142-1.4142c0.1953-0.1953,0.5118-0.1953,0.7071,0v0c0.1953,0.1953,0.1953,0.5118,0,0.7071l-1.4142,1.4142
      C17.462,7.2455,17.1454,7.2455,16.9501,7.0503z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9293,19.0711L4.9293,19.0711c-0.1953-0.1953-0.1953-0.5118,0-0.7071
      l1.4142-1.4142c0.1953-0.1953,0.5118-0.1953,0.7071,0h0c0.1953,0.1953,0.1953,0.5118,0,0.7071l-1.4142,1.4142
      C5.4412,19.2663,5.1246,19.2663,4.9293,19.0711z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.0507,7.0503L7.0507,7.0503c-0.1953,0.1953-0.5118,0.1953-0.7071,0
      L4.9293,5.636c-0.1953-0.1953-0.1953-0.5118,0-0.7071l0,0c0.1953-0.1953,0.5118-0.1953,0.7071,0l1.4142,1.4142
      C7.2459,6.5384,7.2459,6.855,7.0507,7.0503z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.0715,19.0711L19.0715,19.0711c-0.1953,0.1953-0.5118,0.1953-0.7071,0
      l-1.4142-1.4142c-0.1953-0.1953-0.1953-0.5118,0-0.7071l0,0c0.1953-0.1953,0.5118-0.1953,0.7071,0l1.4142,1.4142
      C19.2667,18.5592,19.2667,18.8758,19.0715,19.0711z"/>
  </g>
</template>

<script>
export default {
  name: 'ClearDay'
}
</script>